/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

const reverse = (p: any) => new Promise((resolve, reject) => Promise.resolve(p).then(reject, resolve));
const PromiseAny = (arr: any) => reverse(Promise.all(arr.map(reverse)));

async function getFirstFillfiledPromise(promises: any[]) {
    let first = await PromiseAny(promises);
    return first;
}

export default getFirstFillfiledPromise;
